import { gql } from 'apollo-angular';

export const CREATE_PAYMENT = gql`
  mutation createPayment(
    $createPaymentInput: CreatePaymentInput!,
    $invoiceIDAmountInput: [InvoiceAmountInput!],
    $billIDAmountInput: [BillAmountInput!]
  ) {
    createPayment(
      createPaymentInput: $createPaymentInput,
      invoiceIDAmountInput: $invoiceIDAmountInput,
      billIDAmountInput: $billIDAmountInput
    ) {
      id
      paymentType
      amount
    }
  }
`;

export const UPDATE_PAYMENT = gql`
  mutation updatePayment(
    $id: Int!,
    $updatePaymentInput: CreatePaymentInput!,
    $invoiceIDAmountInput: [InvoiceAmountInput!],
    $billIDAmountInput: [BillAmountInput!]
  ) {
    updatePayment(
      id: $id
      updatePaymentInput: $updatePaymentInput
      invoiceIDAmountInput: $invoiceIDAmountInput
      billIDAmountInput: $billIDAmountInput
    ) {
      id
      paymentType
      amount
    }
  }
`;

export const APPROVE_PAYMENT = gql`
  mutation approvePayment($id: Int!) {
    approvePayment(id: $id) {
      id
      paymentType
      amount
    }
  }
`;

export const CANCEL_PAYMENT = gql`
  mutation cancelPayment($paymentId: Int!) {
    cancelPayment(paymentId: $paymentId) 
  }
`;

export const GENERATE_PAYMENT_PDF = gql`
  mutation generatePaymentPdf($id: Int!) {
    generatePaymentPdf(id: $id) 
  }
`;
